import { motion } from "framer-motion";
import { IMAGES } from "../data/site";

const STATS = [
  { value: "12+", label: "Years manufacturing" },
  { value: "40D", label: "High-density cores" },
  { value: "5.0", label: "Customer rating" },
  { value: "100%", label: "Made to order" },
];

export const Materials = () => {
  return (
    <section id="craft" data-testid="materials-section" className="relative">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* Text */}
        <div className="bg-foreground text-primary-foreground px-4 md:px-16 py-24 md:py-40 flex flex-col justify-center">
          <p className="overline mb-6" style={{ color: "#7BA7CC" }}>
            Materials & Craft
          </p>
          <h2 className="font-heading font-light text-4xl md:text-6xl leading-[1.05] tracking-tight mb-8">
            Poured, cured and
            <br />
            <span className="italic" style={{ color: "#7BA7CC" }}>finished by hand.</span>
          </h2>
          <p className="text-base md:text-lg leading-relaxed text-primary-foreground/70 max-w-lg mb-14">
            From the density of the core to the breathability of the top layer,
            every specification is controlled in our own Delhi factory. No
            outsourcing, no compromise — just foam engineered to last.
          </p>

          <div className="grid grid-cols-2 gap-x-8 gap-y-10 max-w-lg">
            {STATS.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                data-testid={`stat-${i}`}
                className="border-t border-white/15 pt-4"
              >
                <div className="font-heading text-4xl md:text-5xl mb-1">{s.value}</div>
                <div className="text-xs uppercase tracking-[0.18em] text-primary-foreground/50">
                  {s.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Image */}
        <div className="relative overflow-hidden min-h-[50vh] lg:min-h-full">
          <motion.img
            src={IMAGES.materials}
            alt="Foam texture close-up"
            initial={{ scale: 1.15 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>
      </div>
    </section>
  );
};
